import {
	AnimatePresence as AnimatePresenceComponent,
	AnimationProps,
	HTMLMotionProps,
	motion,
} from 'framer-motion';

import React from 'react';

interface AnimatePresenceProps extends HTMLMotionProps<'div'> {
	className?: string;
	elementKey: string;
	transition?: AnimationProps['transition'];
	initial?: AnimationProps['initial'];
	animate?: AnimationProps['animate'];
	exit?: AnimationProps['exit'];
	tag?: 'div' | 'span';
}

function AnimatePresence({
	children,
	className,
	elementKey,
	transition,
	initial,
	animate,
	exit,
	tag = 'div',
	...rest
}: AnimatePresenceProps) {
	const MotionComp = motion[tag];

	return (
		<AnimatePresenceComponent>
			<MotionComp
				key={elementKey}
				className={className}
				initial={initial || { opacity: 0 }} // on mount
				animate={animate || { opacity: 1 }} // after mount
				exit={exit || { opacity: 0 }} // before unmount
				transition={{ duration: 0.4, ...(transition || {}) }}
				{...rest}
			>
				{children}
			</MotionComp>
		</AnimatePresenceComponent>
	);
}

export default AnimatePresence;
